<mat-dialog-content>
  <input (input)="search($event)" [value]="query" placeholder="Suchen..." style="width: 100%; margin-bottom: 10px;" />
  <ng-container *ngFor="let hit of hits; let j = index; trackBy: trackByObjectID">
    <mat-card appearance="outlined" class="ais-Hits-item" (click)="chooseClient(hit)"
      style="display: flex; flex-direction: row; cursor: pointer; margin-bottom: 5px;" [class.grey]="j % 2 === 1">
      <div style="display: flex; flex-grow: 1; flex-direction: column;">
        <mat-card-title>
          {{ hit.name }}
        </mat-card-title>
        <div style="display: flex; flex-direction: column;">
          <span>{{ hit.ansprechpartner }}</span>
          <span>{{ hit.email }}</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; ">
        <button mat-icon-button style="margin-left: 15px;">
          <mat-icon>forward</mat-icon>
        </button>
      </div>
    </mat-card>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-button mat-dialog-close tabindex="-1"><span>Abbrechen</span></button>
</mat-dialog-actions>